import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    title: 'Claritate și direcție',
    desc: 'știi cine ești, ce vrei și încotro mergi, fără confuzie și fără sentimentul că trăiești viața altcuiva'
  }, {
    title: 'Calm în locul stresului cronic',
    desc: 'înveți să reduci încărcătura emoțională și să ieși din modul permanent de alertă în care trăiești'
  }, {
    title: 'Încredere autentică în tine',
    desc: 'nu mai ai nevoie de validarea altora ca să știi că ești pe drumul bun'
  }, {
    title: 'Aliniere cu misiunea ta',
    desc: 'descoperi ce are sens pentru tine și ce te reprezintă, dincolo de rolurile pe care le joci'
  }, {
    title: 'Relații mai sănătoase',
    desc: 'pui limite fără vinovăție, comunici clar și alegi conștient cu cine și cum investești energia'
  }, {
    title: 'Eliberare de tiparele moștenite',
    desc: 'vezi ce porți din familia ta și alegi ce păstrezi, ce transformi și ce lași în urmă'
  }, {
    title: 'Proces integrat, nu teorie',
    desc: 'lucrăm simultan pe minte, emoții și sistemul tău, nu pe bucăți, ca schimbarea să fie reală'
  }, {
    title: 'Suport continuu',
    desc: 'ai ghidare, comunitate și sesiuni live lunare pe toată durata celor 9 luni'
  }];
  return <section className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-282">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-283">
        <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-284">
          <FadeIn data-id="element-285">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-286">
              Ce obții concret prin ANIMA Recode
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-287">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-288">
              <div className="bg-ivory/50 border border-gold/20 rounded-[20px] p-8 h-full flex items-start gap-5 hover:bg-ivory transition-colors duration-300" data-id="element-289">
                <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-290">
                  <CheckCircle2 className="w-5 h-5 text-gold-dark" data-id="element-291" />
                </div>
                <div data-id="element-292">
                  <h3 className="text-[19px] font-medium text-forest mb-2" data-id="element-293">
                    {benefit.title}:
                  </h3>
                  <p className="text-[18px] text-charcoal/70 leading-relaxed" data-id="element-294">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}